import { combineReducers, Reducer, AnyAction } from '@reduxjs/toolkit';

import reducerMapsList from './reducer/reducerMapsList';

interface MapReducers {
	mapsList: Reducer<any, AnyAction>;
}

const MapStore = combineReducers<MapReducers>({
	mapsList: reducerMapsList,
});

export default MapStore;
